import React, {useContext, useState} from 'react';
import {Card, Col, Tab, Tabs} from "react-bootstrap";
import Row from "react-bootstrap/Row";
import {Context} from "../../index";
import BsrCalcTool from "../tools/BsrCalcTool";
import AmazonSuggestions from "../tools/AmazonSuggestions";
import UserWishlist from "../useraccount/UserWishlist";
import FaqUserDashboard from "./FaqUserDashboard";
import BadgeTable from "./BadgeTable";
import NewsAndUpdates from "../news/NewsAndUpdates";
import AiHelper from "../aihelper/AiHelper";
import AIhelper from "../aihelper/AiHelper";
import {AIHelperProvider} from "../aihelper/AIHelperContext";

const ToolsInDashboard = () => {
    const { user } = useContext(Context);

    const [key, setKey] = useState('instructions');

    return (
        <Card className="p-2 w-100 mt-2">
            <Row className="p-2">

                <Col>
                    <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="mb-3 nav-success" >
                        <Tab eventKey="instructions" title="Virtalibry Tools" className="">
                            <h5 className="text-muted">Virtalibry Tools</h5>
                            <div className="text-muted small">
                                <p className="mb-2">
                                    This section offers powerful tools designed to help <em>authors, marketers, and publishers</em> succeed on Amazon.
                                    Each tab provides a focused utility that enhances your book visibility, refines your strategy, and strengthens our community of verified reviewers.
                                </p>

                                <p className="mb-2">
                                    Use the <strong>BSR Calculator for Amazon Books & Royalties</strong> to predict how many copies a book sells based on its BSR (Best Seller Rank).
                                    <br /><br />
                                    On the <strong>Amazon Suggestions</strong> tab, you can instantly generate keyword suggestions from Amazon’s search bar.
                                    <br />
                                    Discover what readers are searching for and export suggestions for further keyword optimization. Ideal for titles, subtitles, and ad strategies.
                                    <br /><br />
                                    The <strong>User Wishlist</strong> tab lets you submit your own feature requests or ideas for improving the platform.
                                    <br />
                                    Our team regularly reviews these submissions — many features are born directly from this feedback.
                                    <br /><br />
                                    The <strong>FAQ for Authors</strong> tab answers common questions about verified reviews, subscription plans, Amazon rules, and platform features.
                                    <br />
                                    It’s regularly updated to reflect changes in both our service and the Amazon ecosystem.
                                </p>

                                <p className="mb-2">
                                    Each tool is designed to empower your publishing journey — whether you're launching your first book or scaling a full catalog.
                                    Together, we’re building a smarter, fairer author ecosystem.
                                </p>
                            </div>
                        </Tab>

                        <Tab eventKey="bsr_calculator" title="BSR Calculator">
                            <BsrCalcTool />
                        </Tab>
                        <Tab eventKey="wishlist" title="Wishlist">
                            <UserWishlist />
                        </Tab>
                        <Tab eventKey="bage_meaning" title="Badge Meaning">
                            <BadgeTable />
                        </Tab>
                        <Tab eventKey="faq" title="FAQ">
                            <FaqUserDashboard />
                        </Tab>
                        <Tab eventKey="news" title="News">
                            <NewsAndUpdates />
                        </Tab>
                    </Tabs>
                </Col>
            </Row>
        </Card>
    );
};

export default ToolsInDashboard;